// src/app/services/adpGage.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { IStarter, IStarterParams, UpdatePayload } from '../models';

export const starterApi = createApi({
  reducerPath: 'starterApi',
  baseQuery,
  endpoints: (builder) => ({
    getStarterParams: builder.query<{ starter: IStarterParams }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/starter/params/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getStarter: builder.query<IStarter, number>({
      query: (id) => `/api/v1.0/ahu/starters/${id}`,
      transformResponse: (data: IStarter) => {
        data.overloadParams = data.starter_overload_params
          ? JSON.parse(data.starter_overload_params)
          : {};
        data.contactorParams = data.starter_contactor_params
          ? JSON.parse(data.starter_contactor_params)
          : {};
        return data;
      },
    }),
    getAllStartersOverloadsCount: builder.query<{ count: number }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/starter/overloads/all/count/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getStartersOverloadsCount: builder.query<{ count: number }, string>({
      query: (queryString) =>
        `/api/v1.0/cms/1/v1.0.0/ahu/starter/overloads/all/count/?${queryString}`,
      extraOptions: {
        cacheData: true,
      },
    }),
    getAllStartersContactorsCount: builder.query<{ count: number }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/starter/contactors/all/count/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getStartersContactorsCount: builder.query<{ count: number }, string>({
      query: (queryString) =>
        `/api/v1.0/cms/1/v1.0.0/ahu/starter/contactors/all/count/?${queryString}`,
      extraOptions: {
        cacheData: true,
      },
    }),
    updateStarter: builder.mutation<IStarter, UpdatePayload<IStarter>>({
      query: ({ id, body, signal }) => ({
        url: `/api/v1.0/ahu/starters/${id}`,
        method: 'PATCH',
        body,
        signal,
      }),
      transformResponse: (data: IStarter) => {
        data.overloadParams = data.starter_overload_params
          ? JSON.parse(data.starter_overload_params)
          : {};
        data.contactorParams = data.starter_contactor_params
          ? JSON.parse(data.starter_contactor_params)
          : {};
        return data;
      },
    }),
  }),
});

export const {
  useLazyGetStarterQuery,
  useGetStarterParamsQuery,
  useGetAllStartersContactorsCountQuery,
  useGetAllStartersOverloadsCountQuery,
  useLazyGetStartersContactorsCountQuery,
  useLazyGetStartersOverloadsCountQuery,
  useGetStarterQuery,
  useUpdateStarterMutation,
} = starterApi;
